import { useTranslation } from 'react-i18next';
import { ShiftInfoTranslator } from '../../../shift-detail-head/shift-info-button/shift-info-translator';
import { LogTabIdentifier } from '../../types/log-tabs';
import { LogsList } from '../../logs-list/logs-list';
import { HistoryEvent } from '../../../shift-detail-head/shift-info-button/types';

export const useGetLogTabs = (history: HistoryEvent[]) => {
  const pastLogs = getTranslatedPastLogs(history);
  const { t } = useTranslation('ogp-screen-specific');

  return [
    {
      id: LogTabIdentifier.PAST,
      tabLabel: t('shift_logs.past_events.tab_label'),
      element: <LogsList logs={pastLogs} />,
    },
    {
      id: LogTabIdentifier.FUTURE,
      tabLabel: t('shift_logs.future_events.tab_label'),
      element: <></>,
    },
  ];
};

const getTranslatedPastLogs = (history: HistoryEvent[]) => {
  const translator = new ShiftInfoTranslator();

  return translator.translateEvents(history);
};
